import  { useEffect, useState } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title
} from "chart.js";
import { CircularProgress, Container, Typography, Box } from "@mui/material";
import config from "../../config.js";

ChartJS.register(
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title
);

const MileageChart = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/v1/logisticJson`
        );
        const rawData = response.data.data.Data;

        const months = [...new Set(rawData.map(item => item["Month"]))];

        const mileageData = months.map(month => {
          const monthData = rawData.filter(item => item["Month"] === month);
          return monthData.reduce((total, item) => total + item["Mileage"], 0);
        });

        const fuelConsumptionData = months.map(month => {
          const monthData = rawData.filter(item => item["Month"] === month);
          return monthData.reduce((total, item) => total + item["Fuel Сonsumption"], 0);
        });

        const datasets = [
          {
            label: 'Mileage',
            data: mileageData,
            backgroundColor: 'rgba(75, 192, 192, 0.6)',
            borderColor: 'rgba(75, 192, 192, 1)',
            borderWidth: 1,
            yAxisID: 'y-axis-1',
            fill: false
          },
          {
            label: 'Fuel Consumption',
            data: fuelConsumptionData,
            backgroundColor: 'rgba(255, 99, 132, 0.6)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 1,
            yAxisID: 'y-axis-2',
            fill: false
          }
        ];

        setChartData({
          labels: months,
          datasets: datasets,
        });
      } catch (error) {
        setError(error);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!chartData.labels.length) {
    return (
      <Container
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Container>
    );
  } else {
    const options = {
      responsive: true,
      scales: {
        x: {
          beginAtZero: true,
        },
        y: {
          beginAtZero: true,
          type: 'linear',
          display: true,
          position: 'left',
          id: 'y-axis-1',
        },
        'y-axis-2': {
          beginAtZero: true,
          type: 'linear',
          display: true,
          position: 'right',
          grid: {
            drawOnChartArea: false, // only want the grid lines for one axis to show up
          },
        },
      },
      plugins: {
        legend: {
          display: true,
          labels: {
            color: 'white',
            font: {
              size: 14
            }
          }
        }
      },
    };

    return (
      <div>
        <Box sx={{ backgroundColor: "#FF4D4D", padding: 2, borderRadius: 1 }}>
          <Typography variant="h5" sx={{ color: "#fff", textAlign: "center" }}>
            Mileage and Fuel Consumption by Month
          </Typography>
        </Box>
        <Container>
          <div
            style={{
              padding: "20px",
              width: "100%",
              height: "80%",
            }}
          >
            <Line
              data={chartData}
              options={options}
            />
          </div>
        </Container>
      </div>
    );
  }
};

export default MileageChart;
